import "../chunk-5WRI5ZAA.js";

// src/logger/logger.ts
var PublicLogger = class {
  static logEvent(logCallback, message) {
    if (typeof process !== "undefined" && process?.env?.NODE_ENV !== "test") {
      logCallback("Live_Preview_SDK:", ...message);
    }
  }
  static error() {
    for (var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++) {
      data[_key] = arguments[_key];
    }
    this.logEvent(console.error, data);
  }
  static warn() {
    for (var _len2 = arguments.length, data = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      data[_key2] = arguments[_key2];
    }
    this.logEvent(console.warn, data);
  }
  static debug() {
    for (var _len3 = arguments.length, data = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      data[_key3] = arguments[_key3];
    }
    this.logEvent(console.debug, data);
  }
};
export { PublicLogger };